module.exports = __webpack_public_path__ + "img/download-cloud-icon.9b8407fb.svg";